import React, { useState, useEffect } from "react"
import Axios from "axios";
import { EventList } from './EventList';
import { EventDetails } from './EventDetails';

function BookYourExperience() {
  const [ eventList, setEventList] = useState([]);
  const [ currentEventID, setcurrentEventID] = useState();
  const fetchEvents = () => {
      Axios.get("/wp-json/wp/v2/events?_embed")
          .then((res) => {
              setEventList(res.data);
      });
  };
  //
  useEffect(() => {
    fetchEvents();
  }, []);
  //
  return (
    <>
      <EventList eventList={eventList} currentEventID={currentEventID} setcurrentEventID={setcurrentEventID} />
      <EventDetails eventList={eventList} currentEventID={currentEventID} />
    </>
  )
}

export default BookYourExperience